<template>
  <div class="processed">
    <div class="processed_top">
      <ToProcessed :isShow="false"></ToProcessed>
    </div>
    <div class="processed_bottom container_width">
      <div class="processed_title">举报处理</div>
      <ul class="data_detail">
        <li v-for="(item,index) of ToProcessedData" :key="index">
          <span class="category">{{item.category}}：</span>
          <span class="data_infor">{{item.dataInfor}}</span>
        </li>
        <li v-if="materialData.length">
          <span class="category">材料：</span>
          <div class="reporting_material">
            <div class="data_detaillist" v-for="(item,index) of materialData" :key="index">
              <span class="data_detail_name">{{item}}</span>
              <!-- <span class="download_icon el-icon-bottom" @click="aloneDownload(index)"></span> -->
            </div>
            <!-- <div class="all_download" @click="allDownload">全部下载</div> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ToProcessed from "@/views/ReportPlatform/ToProcessed.vue";
import { reportDetail, downReport } from "common/js/api";

export default {
  name: "Processed",
  components: {
    ToProcessed
  },
  data() {
    return {
      id: this.$route.query.id,
      companyName: this.$route.query.companyName,
      ToProcessedData: [
        {
          category: "事项处理过程",
          dataInfor: ""
        },
        {
          category: "对入驻机构采取的措施",
          dataInfor: ""
        },
        {
          category: "处理人",
          dataInfor: ""
        },
        {
          category: "处理时间",
          dataInfor: ""
        }
      ],
      materialData: []
    };
  },

  created() {
    this.getDetail();
  },

  methods: {
    async getDetail() {
      const { result } = await reportDetail( this.id );
      this.ToProcessedData[0].dataInfor = result.handleProcessDesc;
      this.ToProcessedData[1].dataInfor = result.handleReportMeasure;
      this.ToProcessedData[2].dataInfor = result.handleName;
      this.ToProcessedData[3].dataInfor = result.updatedTime;
      this.materialData = result.handleReportFileUrls || [];
    },

    allDownload() {
      for (let i = 0; i < this.materialData.length; i++) {
        this.aloneDownload(i);
      }
    },

    async aloneDownload(index) {
      await downReport(this.id, index, 1);
    },

    goBack() {
      
      //   this.$router.go("-1");
    },
    result() {
      
    },
    allDownload() {
      
    },
    aloneDownload(fileName, fileId) {
     
    }
  }
};
</script>

<style scoped>
.processed_top >>> .deal_with {
  display: none;
}
.processed_top {
  border-bottom: 1px dashed #d5d5d5;
}
.processed_title {
  font-size: 28px;
  color: #0f1824;
  font-weight: bold;
  margin: 40px 0 30px;
}
.data_detail {
  margin-top: 20px;
}
.category {
  font-size: 14px;
  font-weight: bold;
  color: #0f1824;
  vertical-align: middle;
}
.data_infor {
  font-size: 14px;
  line-height: 20px;
  color: #6c7885;
}
.data_detail li {
  margin-bottom: 20px;
}
.reporting_material {
  width: calc(100% - 55px);
  display: inline-block;
}
.button_style,
.all_download {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 100px;
  height: 28px;
  line-height: 28px;
}
.deal_with {
  margin-top: 40px;
}
.cancel,
.all_download {
  border: 1px solid #dddddd;
  border-radius: 2px;
  margin-right: 16px;
}
.all_download {
  font-size: 14px;
  color: #3165ff;
  border: 1px solid #3165ff;
  border-radius: 2px;
  margin-top: 35px;
}
.asubmit {
  background: #3165ff;
  border-radius: 2px;
  color: #fff;
}
.data_detaillist {
  position: relative;
  background: #f3f3f3;
  border-radius: 2px;
  padding: 3px;
  margin-bottom: 2px;
  padding: 5px 8px;
  width: 100%;
}
.download_icon {
  cursor: pointer;
  position: absolute;
  right: 10px;
  color: #fff;
  font-size: 12px;
  width: 16px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  background: #fb5353;
}
.data_detail_name {
  font-size: 14px;
  color: #3165ff;
}
</style>
